import { render } from "./LoadingComponent.vue?vue&type=template&id=3d954c38"
import script from "./LoadingComponent.vue?vue&type=script&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=3d954c38&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__